import {performRequest, TRequestPromise} from 'shared/utils';
import {IDocumentsUploadMonitoringResult, IExecuteMonitoringData} from 'store/slices/documents-uploading-slice';

export const markDownLoadedList = (data: number[]): TRequestPromise => performRequest({
    url: 'monitor/rpc/mark-downloaded-list',
    method: 'POST',
    data: {
        ids: data,
    },
});

export const markDownLoadedAll = (data: any): TRequestPromise => performRequest({
    url: 'monitor/rpc/mark-downloaded-all',
    method: 'POST',
    data,
});

export const fetchRequestListInfo = (params?: {
    paginationCurrent?: number;
    paginationPageSize?: number;
    search?: string;
}): TRequestPromise<any> => performRequest({
    url: 'monitor/list-request-info',
    method: 'GET',
    params,
});

export const fetchDocumentsExecuteMonitoringData = (monitorProgramId: any, data: IExecuteMonitoringData):
    TRequestPromise<string> => performRequest(
    {
        url: `/monitor/execute/${monitorProgramId}`,
        method: 'POST',
        data,
    },
);

export const fetchDocumentsUploadMonitoringData = (monitoringSetId: number):
    TRequestPromise<IDocumentsUploadMonitoringResult[]> => performRequest({
    url: `/monitor/set/${monitoringSetId}`,
    method: 'GET',
});

export const downloadMonitoringProgramLog = (monitorProgramRequestId: number): TRequestPromise<void> => performRequest({
    url: `administration.monitor.programs/download/${monitorProgramRequestId}`,
    method: 'GET',
});
